import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGrid = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18.4281 7.28553C18.4281 9.65237 16.5094 11.5711 14.1425 11.5711C11.7757 11.5711 9.85702 9.65237 9.85702 7.28553C9.85702 4.9187 11.7757 3 14.1425 3C16.5094 3 18.4281 4.9187 18.4281 7.28553Z"
      fill="#0152F8"
    />
    <path
      d="M20.9996 16.1865C20.9996 18.3843 17.9296 19.2633 14.1427 19.2633C10.3558 19.2633 7.28586 18.3843 7.28586 16.1865C7.28586 14.2117 10.3558 13.1098 14.1427 13.1098C17.9296 13.1098 20.9996 13.9888 20.9996 16.1865Z"
      fill="#0152F8"
    />
    <path
      d="M14.1422 9.0222C14.1422 11.389 12.2235 13.3077 9.85669 13.3077C7.48986 13.3077 5.57116 11.389 5.57116 9.0222C5.57116 6.65536 7.48986 4.73667 9.85669 4.73667C12.2235 4.73667 14.1422 6.65536 14.1422 9.0222Z"
      fill="#0D6EDE"
    />
    <path
      d="M16.7137 17.9232C16.7137 20.1209 13.6438 21 9.85685 21C6.06992 21 3 20.1209 3 17.9232C3 15.9483 6.06992 14.8464 9.85685 14.8464C13.6438 14.8464 16.7137 15.7255 16.7137 17.9232Z"
      fill="#0D6EDE"
    />
  </svg>
);
export default SvgGrid;
